import React from "react";

const ReportDelete = () => {
  return <h1>Report Delete</h1>;
};

export default ReportDelete;
